<template>
	<el-form ref="fixRateForm" :model="detailFrom" :rules="rules">
		<div v-for="(item, index) in detailFrom.detail" :key="index" class="a-felx-cfsfs a-mt-10 projectadd-box">
			<div class="a-flex-rfsc">
                <le-company-underandparent-select 
                    :label="(allowChildRate ? '一级收益方' : '收益方') + (index + 1)" 
                    v-model="item.targetCompanyInfo" 
                    isObj
                    large
                    :readonly="isInvestorLocked(item)"
                    :defaultOptions="getCompanyDefaultOptions(item)">
                </le-company-underandparent-select>
                <el-tag class="a-ml-10" v-for="(ite,index) in getVisiblePayPlatform(item)" :key="index">{{ util.initDic(ite.servicePlatform, 'servicePlatform') }}</el-tag>
				<i class="el-icon-remove-outline a-c-red a-fs-16 a-ml-15" v-if="index > 0 && !item.notDel && !isInvestorLocked(item)" @click="handlerDelFixedIncome(index)"></i>
			</div>
            <div class="a-flex-rfsfs" v-if="company.isSystem && (userInfo.dataPermission == 99)">
                <le-select-local-search 
                    label="上级商户" 
                    large
                    v-model="item.showCompanyId" 
                    :options="showCompanyOptions" />
			</div>
			<el-form-item :prop="'detail.' + index + '.rate'" :rules="{ validator: validateDetail, trigger: 'change' }">
				<div class="a-flex-rfsc">
					<span style="width: 140px; margin-top: 4px">分成比例</span>
					<el-input placeholder="请输入分成比例" type="number" min="0" v-model="item.rate" large
						style="width: 376px !important" :max="maxRate" :disabled="isInvestorLocked(item)">
						<template slot="append">%</template>
					</el-input>
				</div>
			</el-form-item>

			<div class="child-rate-wrap" v-if="showChildWrap(item)">
				<div v-for="(child, cIndex) in item.childList" :key="cIndex" class="child-rate-item">
					<div class="a-flex-rfsc">
						<le-company-underandparent-select 
							:label="'二级收益方' + (cIndex + 1)" 
							v-model="child.targetCompanyInfo" 
							isObj
							large
							:defaultOptions="getCompanyDefaultOptions(child)">
						</le-company-underandparent-select>
						<el-tag class="a-ml-10" v-for="(ite, pIndex) in getVisiblePayPlatform(child)" :key="pIndex">{{ util.initDic(ite.servicePlatform, 'servicePlatform') }}</el-tag>
						<i class="el-icon-remove-outline a-c-red a-fs-16 a-ml-15" v-if="canItemAddChild(item)" @click="handlerDelChild(index, cIndex)"></i>
					</div>
					<el-form-item
						:prop="'detail.' + index + '.childList.' + cIndex + '.rate'"
						:rules="{ validator: validateChildDetail, trigger: 'change' }">
						<div class="a-flex-rfsc">
							<span style="width: 140px; margin-top: 4px">分成比例</span>
							<el-input placeholder="请输入分成比例" type="number" min="0" v-model="child.rate" large
								style="width: 376px !important" :max="maxRate">
								<template slot="append">%</template>
							</el-input>
						</div>
					</el-form-item>
				</div>
				<div class="a-flex-rfsc a-mt-10 font-point" v-if="canItemAddChild(item)" @click="handlerAddChild(index)">
					<i class="el-icon-circle-plus-outline a-c-blue a-fs-16"></i>
					<span class="a-ml-03 a-c-blue">添加二级收益方</span>
					<span class="a-ml-10 a-c-second a-fs-12" v-if="item.childList && item.childList.length">二级合计需等于本级 {{ item.rate || 0 }}%</span>
				</div>
			</div>
		</div>
		<div class="a-flex-rfsc a-mt-10 addFixedIncom font-point" @click="handlerAddFixedIncome">
			<i class="el-icon-circle-plus-outline a-c-blue a-fs-16"></i>
			<span class="a-ml-03 a-c-blue">{{ allowChildRate ? '添加一级收益方' : '添加' }}</span>
		</div>
	</el-form>
</template>

<script>
    import util from "../../utils/util.js";
	import {
		mapState
	} from 'vuex';
	import { createEmptyRateItem, mapFixedItemFromApi, getMaxSerNo, isRateEqual, isTargetSplitModeTwo, getInvestorCompanyIdFromTarget } from './income-rate-helper.js'
	export default {
		props: {
			value:{
				type:Array
			},
			incomeId: {
				type: Number,
			},
			maxRate: {
				type: Number
			},
			ownerCompanyId: {
				type: Number
			},
			allowChildRate: {
				type: Boolean,
				default: false
			},
			targetInfo: {
				default: null
			},
			investorCompanyId: {
				default: null
			}
		},
		computed: {
			...mapState({
				company: state => state.company.company,
                userInfo: state => state.user.user,
			}),
			lockTargetInfo() {
				if (this.incomeTargetInfo !== undefined) {
					return this.incomeTargetInfo
				}
				return isTargetSplitModeTwo(this.targetInfo) ? this.targetInfo : null
			}
		},
		data() {
			return {
                util,
				incomeTargetInfo: undefined,
				detailFrom:{
					detail: [],
				},
				ownerRate:0,//本商户收益
				rules: {},
                fZTemplateOptions: {
                    url: this.$Config.apiUrl.getIncomePlanList,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "planName",
                    valueKey: "id",
                    searchKey: "planName",
                },
                showCompanyOptions: [{
                    label: '上海玖电科技有限公司',
                    value: 2
                }]
			}
		},
		watch: {
			value:{
				handler(val) {
					if (!val) return
					if (!val.length && this.incomeId && this.detailFrom.detail.length) return
					val.forEach(item => {
						if (!item.childList) {
							this.$set(item, 'childList', [])
						}
					})
					this.detailFrom.detail = val
				},
				deep:true,
				immediate:true
			},
			incomeId: {
				handler(val) {
					this.incomeTargetInfo = undefined
					if (val) {
						this.getIncomeDetail();
					}
				},
				immediate: true
			},
			maxRate: {
				handler(val) {
					this.setDefaultRate()
				}
			},
			ownerCompanyId:{
				handler(val) {
					this.setDefaultRate()
				}
			},
			'detailFrom.detail':{
				handler(val) {
					this.$emit('input',val)
				},
				deep:true,
			},
		},
		methods: {
			/**
			 * 展示用钱包列表；默认隐藏蚂蚁钱包（servicePlatform = 6）
			 * splitMode === 2（可添加二级）时展示蚂蚁钱包
			 */
			getVisiblePayPlatform(item) {
				let list = item && item.targetCompanyInfo && item.targetCompanyInfo.payPlatform
				if (!Array.isArray(list)) return []
				if (this.allowChildRate) return list
				return list.filter(p => p.servicePlatform != 6)
			},
			ensureChildList(item) {
				if (!item.childList) {
					this.$set(item, 'childList', [])
				}
			},
			/**
			 * 设置默认收益比例
			 */
			setDefaultRate() {
				if (this.incomeId) return
				if (this.maxRate && this.ownerCompanyId && this.detailFrom.detail.length == 0) {
					this.detailFrom.detail.push(createEmptyRateItem({
						serNo: 0,
						rate: this.maxRate,
						payCompany: 1,
						company: this.company,
					}))
				}
			},
			/**
			 * 获取项目详情
			 */
			getIncomeDetail() {
				this.$Axios._get({
						url: this.$Config.apiUrl.gitEditIncomeDetailInfo,
						params: {
							incomeId: this.incomeId,
						},
					})
					.then(({
						data
					}) => {
						this.incomeTargetInfo = data.targetInfo || null
						this.detailFrom.detail = (data.targetList || data.detail || []).map(item => mapFixedItemFromApi(item))
					});
			},
			/**
			 * 添加一级收益条目
			 */
			handlerAddFixedIncome() {
				let rateDetai = createEmptyRateItem({
					serNo: getMaxSerNo(this.detailFrom.detail) + 1,
					rate: 0,
					payCompany: 0,
				});
				this.detailFrom.detail.push(rateDetai);
			},
			handlerAddChild(index) {
				let parent = this.detailFrom.detail[index]
				if (!this.canItemAddChild(parent)) return
				this.ensureChildList(parent)
				parent.childList.push(createEmptyRateItem({
					serNo: getMaxSerNo(this.detailFrom.detail) + 1,
					rate: 0,
					payCompany: 0,
				}))
			},
			handlerDelChild(index, cIndex) {
				let parent = this.detailFrom.detail[index]
				if (parent && parent.childList) {
					parent.childList.splice(cIndex, 1)
				}
			},
			
			handlerDelFixedIncome(index){
				this.detailFrom.detail.splice(index,1)

                let payCompanyInfo = this.detailFrom.detail.find(res=>{
					return res.payCompany == 1
				})
				if(!payCompanyInfo) {
					this.$set(this.detailFrom.detail[0], 'payCompany', 1)
				}
			},

            handleSetPayCompany (datas) {
                let targetCompanyId = datas.targetCompanyId || datas.targetCompanyInfo.value
                if(!targetCompanyId) {
                    this.$message.error('请先选择收益方')
                    return
                }
                this.detailFrom.detail.map(item=>{
                    if(item.targetCompanyId == targetCompanyId || item.targetCompanyInfo.value == targetCompanyId) {
                        this.$set(item, 'payCompany', 1)
                    }else {
                        this.$set(item, 'payCompany', 0)
                    }
                })
            },
			getCompanyDefaultOptions(item) {
				let info = item && item.targetCompanyInfo
				if (!info || !info.value) return []
				return [{
					id: info.value,
					name: info.label,
				}]
			},
			getCompanyId(item) {
				if (!item) return null
				let info = item.targetCompanyInfo || {}
				return item.targetCompanyId || info.value || info.id || item.companyId || null
			},
			getInvestorCompanyId() {
				return getInvestorCompanyIdFromTarget(this.lockTargetInfo) || this.investorCompanyId
			},
			isInvestorItem(item) {
				if (!isTargetSplitModeTwo(this.lockTargetInfo)) return false
				let investorId = this.getInvestorCompanyId()
				let companyId = this.getCompanyId(item)
				return investorId != null && investorId !== '' && companyId != null && companyId == investorId
			},
			isInvestorLocked(item) {
				return !!this.incomeId && isTargetSplitModeTwo(this.lockTargetInfo) && this.isInvestorItem(item)
			},
			canItemAddChild(item) {
				return this.allowChildRate && !this.isInvestorItem(item)
			},
			showChildWrap(item) {
				return this.canItemAddChild(item) || (item.childList && item.childList.length)
			},
			isValidRate(value) {
				return (value + '').match(/^\d{1,3}(\.\d{1,2})?$/)
			},
			getChildRateTotal(parent) {
				return (parent.childList || []).reduce((sum, child) => {
					return sum + Number(child.rate || 0)
				}, 0)
			},
			
			/**
			 * form校验
			 * @param {Object} rule
			 * @param {Object} value
			 * @param {Object} callback
			 */
			validateDetail(rule, value, callback) {
				let index = rule.field.split(".")[1];
				let current = this.detailFrom.detail[index]
				let _value = current.rate
				if(!this.isValidRate(_value)){
					return callback(new Error("请输入正确数值,最大"+this.maxRate+",最小0,小数点后最多2位"));
				}
				if(_value>this.maxRate || _value<0){
					return callback(new Error("请输入正确数值,最大"+this.maxRate+",最小0,小数点后最多2位"));
				}
				
				/**
				 * 过滤获取本商户收益
				 */
				this.ownerRate = this.detailFrom.detail.map((item, index) => {
					if(item.targetCompanyInfo && item.targetCompanyInfo.value == this.company.id){
						return item.rate ? item.rate : 0; 
					}else{
						return 0;
					}
				}).reduce(function(prev, cur) {
					return Number(prev) + Number(cur);
				}, 0);
				let totalRate = 0
				this.detailFrom.detail.map(item=>{
					totalRate += Number(item.rate || 0)
				})
				
				if (!this.ownerCompanyId) {
					return callback(new Error("请选择所属商户"));
				} else if (!current.targetCompanyInfo) {
					return callback(new Error("请选择对应的收益方"));
				} else if (totalRate > this.maxRate) {
					return callback(new Error("设置的分成总比例"+totalRate+"%不能超过最大可分配比例"+this.maxRate+'%'));
				} else if (!current.incomePlanId) {
					return callback(new Error('请选择收益方分账模板'));
				} else if (this.canItemAddChild(current) && (current.childList || []).length && !isRateEqual(this.getChildRateTotal(current), _value)) {
					return callback(new Error("二级分成合计必须等于一级分成比例"));
				} else {
					return callback();
				}
			},
			validateChildDetail(rule, value, callback) {
				if (!this.allowChildRate) {
					return callback();
				}
				let parts = rule.field.split(".")
				let pIndex = parts[1]
				let cIndex = parts[3]
				let parent = this.detailFrom.detail[pIndex]
				let child = parent.childList[cIndex]
				let _value = child.rate
				if(!this.isValidRate(_value)){
					return callback(new Error("请输入正确数值,最大"+this.maxRate+",最小0,小数点后最多2位"));
				}
				if(_value>this.maxRate || _value<0){
					return callback(new Error("请输入正确数值,最大"+this.maxRate+",最小0,小数点后最多2位"));
				}
				if (!this.ownerCompanyId) {
					return callback(new Error("请选择所属商户"));
				}
				if (!child.targetCompanyInfo) {
					return callback(new Error("请选择对应的二级收益方"));
				}
				let parentCompanyId = this.getCompanyId(parent)
				let childCompanyId = this.getCompanyId(child)
				// if (parentCompanyId && childCompanyId == parentCompanyId) {
				// 	return callback(new Error("二级收益方不能与一级收益方相同"));
				// }
				let duplicated = (parent.childList || []).some((item, idx) => {
					return idx != cIndex && this.getCompanyId(item) && this.getCompanyId(item) == childCompanyId
				})
				if (duplicated) {
					return callback(new Error("同一一级收益方下二级收益方不能重复"));
				}
				if ((parent.childList || []).length && !isRateEqual(this.getChildRateTotal(parent), parent.rate)) {
					return callback(new Error("二级分成合计必须等于一级分成比例" + (parent.rate || 0) + '%'));
				}
				return callback();
			},
		}
	}
</script>

<style lang="scss" scoped>
	.child-rate-wrap {
		margin-left: 24px;
		padding-left: 16px;
		border-left: 2px solid #dcdfe6;
	}
	.child-rate-item {
		background: #fff;
		border: 1px dashed #dadde0;
		border-radius: 4px;
		padding: 12px 16px 4px;
		margin-top: 12px;
	}
</style>
